export const PERSPECTIVE = "PERSPECTIVE";
export const ORTHOGRAPHIC = "ORTHOGRAPHIC";
